import { render, staticRenderFns } from "./currentt.vue?vue&type=template&id=14da6542&scoped=true&"
import script from "./currentt.vue?vue&type=script&lang=js&"
export * from "./currentt.vue?vue&type=script&lang=js&"
import style0 from "./currentt.vue?vue&type=style&index=0&id=14da6542&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14da6542",
  null
  
)

export default component.exports